import { login, getUserInfo, logout } from "@/api/user";
import { getToken, setToken, removeToken } from "@/utils/auth";
import { computePermissions } from "@/constants/roles";

const state = {
  token: getToken() || "",
  userInfo: {},
  roles: [],
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
    setToken(token);
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  CLEAR_USER: state => {
    state.token = "";
    state.userInfo = {};
    state.roles = [];
    removeToken();
  },
};

const actions = {
  // 用户登录
  login({ commit }, loginForm) {
    return new Promise((resolve, reject) => {
      login(loginForm)
        .then(response => {
          const { token, user } = response.data || {};
          if (token) {
            commit("SET_TOKEN", token);
            if (user) {
              commit("SET_USER_INFO", user);
            }
            resolve(response);
          } else {
            reject(new Error("登录响应中没有找到 token"));
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // 获取用户信息
  getUserInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getUserInfo()
        .then(response => {
          const { data } = response;
          commit("SET_USER_INFO", data);
          commit("SET_ROLES", data.roles || []);
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // 用户登出
  logout({ commit }) {
    return new Promise(resolve => {
      // 先调 API（token 还在），再清除本地状态
      logout().catch(() => { /* ignore */ }).finally(() => {
        commit("CLEAR_USER");
        resolve();
      });
    });
  },

  // 重置用户状态
  resetUser({ commit }) {
    commit("CLEAR_USER");
  },
};

const getters = {
  token: state => state.token,
  userInfo: state => state.userInfo,
  roles: state => state.roles,
  role: state => state.userInfo?.role || "",
  isLogin: state => !!state.token,
  permissions: state => computePermissions(state.userInfo),
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
